import * as React from 'react';

import { ITagSearch } from '@/client/legacy-shared-modules/search/search-types';
import { TagHit } from '@/imports/ui/components/search/TagHits';

import { CardDividerList } from '../shared/CardDividerList';

export const TagsList: React.FC<{
  hits: ITagSearch[];
}> = ({ hits }) => {
  if (hits.length === 0) {
    return null;
  }

  return (
    <CardDividerList>
      {hits.map((tagHit) => (
        <React.Fragment key={tagHit.objectID}>
          {TagHit(tagHit, true)}
        </React.Fragment>
      ))}
    </CardDividerList>
  );
};
